import { useQuery } from "@apollo/client/react";
import clsx from "clsx";

import { SwitcherCustomersDocument } from "@/gql/graphql";
import { useAppSelector } from "@/hooks";

import Customer from "./Customer";
import { switcherSelector } from "./switcherReducer";

type PropsType = {
  chooseCustomer: (customer: SessionCustomer) => void;
  chosenCustomer: Nilable<SessionCustomer>;
};

export default function CustomerList({ chooseCustomer, chosenCustomer }: PropsType) {
  const { onlyActive } = useAppSelector(switcherSelector);

  const { data } = useQuery(SwitcherCustomersDocument, {
    variables: { filters: { active: onlyActive ? true : undefined } },
  });

  if (!data?.customers) return null;

  return (
    <ul className="TT-switcher-customer-list">
      {data.customers.map((c) => (
        <li key={c.id} className={clsx("TT-switcher-customer", { active: chosenCustomer?.id === c.id })}>
          <Customer tag="button" onClick={chooseCustomer} customer={c} />
        </li>
      ))}
    </ul>
  );
}
